import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import { Box, Button, ButtonProps } from "@mui/material";
import BybConditionalWrapper from "../byb-conditional-wrapper";

/**
 *
 * @returns a wrapper for the button component that adds haptics feedback and button functionality (if onClick is present)
 */
const BybButtonWrapper = ({ sx, ...props }: ButtonProps) => {
  return (
    <BybConditionalWrapper
      condition={!!props.onClick || props.type === "submit" || props.type === "button"}
      trueWrapper={children => (
        <HapticsButtonWrapper disabled={props.disabled}>
          <Button disableElevation variant="contained" sx={{ ...sx, whiteSpace: "pre" }} {...props}>
            {children}
          </Button>
        </HapticsButtonWrapper>
      )}
      falseWrapper={children => <Box sx={sx}>{props.children}</Box>}
    >
      {props.children}
    </BybConditionalWrapper>
  );
};

export default BybButtonWrapper;
